import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type { TestConfigInputResponse } from '@eggplant/types'

interface Props {
  id: string
  children?: (data: TestConfigInputResponse) => ReactElement
  onSuccess?: (data: TestConfigInputResponse) => void
  onError?: () => void
}

const GetTestConfigRequest = ({
  id,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/test_configurations/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetTestConfigRequest
